import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Heart, Shield, Zap } from 'lucide-react';
export function SolutionSection() {
  const benefits = ['Nunca más te quedes sin ideas', 'No improvises por falta de tiempo', 'Dejá de vivir buscando recursos todas las semanas', 'No tengas que adaptar cosas que no encajan', 'Recuperá la calma y el disfrute'];
  return <section className="py-20 bg-white overflow-hidden" data-id="element-70">
      <div className="container mx-auto px-4 md:px-6" data-id="element-71">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-72">
          <div className="lg:w-1/2" data-id="element-73">
            <motion.div initial={{
            opacity: 0,
            x: -50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="relative" data-id="element-74">
              <div className="absolute -top-10 -left-10 w-40 h-40 bg-yellow-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob" data-id="element-75"></div>
              <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000" data-id="element-76"></div>

              <div className="relative bg-gradient-to-br from-sky-50 to-white p-8 rounded-3xl border border-sky-100 shadow-xl" data-id="element-77">
                <div className="text-center mb-8" data-id="element-78">
                  <span className="bg-sky-100 text-sky-700 px-3 py-1 rounded-full text-sm font-bold tracking-wide uppercase" data-id="element-79">
                    La Solución
                  </span>
                  <h3 className="text-3xl font-bold text-slate-900 mt-4" data-id="element-80">
                    Mega Pack de Recursos
                  </h3>
                  <p className="text-slate-500 mt-2" data-id="element-81">
                    Sistema completo para Nivel Inicial
                  </p>
                </div>

                <ul className="space-y-4" data-id="element-82">
                  {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-83">
                      <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-84" />
                      <span className="text-slate-700 font-medium" data-id="element-85">
                        {benefit}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-1/2" data-id="element-86">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-87">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-88">
                Imaginá que abrís la compu y...{' '}
                <span className="text-sky-600" data-id="element-89">ya tenés todo listo.</span>
              </h2>
              <p className="text-lg text-slate-600 mb-6 leading-relaxed" data-id="element-90">
                Actividades, recursos, propuestas e ideas pensadas
                específicamente para Nivel Inicial. Organizadas para que elijas
                rápido, sin pensar desde cero.
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-91">
                Llegás a la sala segura. Tranquila. Con opciones. Y volvés a tu
                casa con energía, porque la docencia deja de comerse tu vida
                personal.
              </p>

              <div className="grid grid-cols-2 gap-4" data-id="element-92">
                <div className="bg-orange-50 p-4 rounded-xl border border-orange-100" data-id="element-93">
                  <Zap className="w-6 h-6 text-orange-500 mb-2" data-id="element-94" />
                  <h4 className="font-bold text-slate-800" data-id="element-95">Planificá rápido</h4>
                  <p className="text-sm text-slate-600" data-id="element-96">
                    Ahorrá horas de búsqueda
                  </p>
                </div>
                <div className="bg-purple-50 p-4 rounded-xl border border-purple-100" data-id="element-97">
                  <Shield className="w-6 h-6 text-purple-500 mb-2" data-id="element-98" />
                  <h4 className="font-bold text-slate-800" data-id="element-99">Seguridad</h4>
                  <p className="text-sm text-slate-600" data-id="element-100">
                    Entrá a la sala confiada
                  </p>
                </div>
                <div className="bg-pink-50 p-4 rounded-xl border border-pink-100" data-id="element-101">
                  <Heart className="w-6 h-6 text-pink-500 mb-2" data-id="element-102" />
                  <h4 className="font-bold text-slate-800" data-id="element-103">Disfrute</h4>
                  <p className="text-sm text-slate-600" data-id="element-104">
                    Reconectá con tu vocación
                  </p>
                </div>
                <div className="bg-green-50 p-4 rounded-xl border border-green-100" data-id="element-105">
                  <CheckCircle className="w-6 h-6 text-green-500 mb-2" data-id="element-106" />
                  <h4 className="font-bold text-slate-800" data-id="element-107">Organización</h4>
                  <p className="text-sm text-slate-600" data-id="element-108">
                    Todo en un solo lugar
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}